// Round 4e (47099): the app's one shell reader (see shellRead.logic.mjs): badge counts and display-only boot reads share
// GET /api/shell/badges, flushed after first paint once the page's own reads are quiet.
import api from '../services/api';
import { afterPaint } from './afterPaint.mjs';
import { makeShellReader } from './shellRead.logic.mjs';

const reader = makeShellReader({ request: (path, opts) => api.request(path, opts), schedule: (fn) => { afterPaint(fn); }, hasToken: () => !!api.token });
export const shellRead = reader.read;     // shellRead(part, { fresh }) -> the part's body (rejects on its non-200)
export const shellPoll = reader.poll;     // shellPoll(part, cb) -> unsubscribe; cb(body) or cb(null, err) now + every 60 s
